import { render, staticRenderFns } from "./BeeAutocomplete.vue?vue&type=template&id=5bb2b920&"
import script from "./BeeAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BeeAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports